import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_30px_rgba(234,88,12,0.1)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-122">
          {/* Subtle background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center top, rgba(234,88,12,0.04) 0%, transparent 70%)'
        }} data-id="element-123"></div>

          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 rounded-full flex items-center justify-center mb-8 shadow-inner" data-id="element-124">
            <span className="text-5xl" data-id="element-125">🛡️</span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-6 tracking-tight" data-id="element-126">
            GET YOUR TIME BACK OR GET A REFUND
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-127">
            We are so confident in THE FOOTBALL READY-PACK that we offer a{' '}
            <span className="text-primary font-bold" data-id="element-128">7-day trial</span>. If you
            don't feel that your job as a coach has become significantly easier
            and more organized, we will refund every penny.{' '}
            <span className="text-text-main font-bold" data-id="element-129">
              No questions asked.
            </span>
          </p>
        </div>
      </div>
    </section>;
}